module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de_at":{"What do you want to eat?":"Was willst du kochen?"},"cs":{"What do you want to eat?":"Co chcete vařit?"},"hu":{"What do you want to eat?":"Mit akar főzni?"},"fr":{"What do you want to eat?":"Que voulez-vous cuisiner??"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/PageSearch.vue
// module id = 1197
// module chunks = 0